import styled from 'styled-components';
import { ProgressBarMixin } from '../../mixins/components/ProgressBarMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledProgressBar = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['size', 'value', 'orientation'])
}).withConfig({
  displayName: "StyledProgressBar",
  componentId: "c11n-8-111-1__sc-1ut6l7a-0"
})(["", ""], ProgressBarMixin);